import React from 'react';
import UpdateEmailLayout from '../../components/update-email/UpdateEmailLayout';
import UpdateEmailSecurity from '../../components/update-email/UpdateEmailSecurity';

const UpdateEmailSecurityPage = (props) => (
  <UpdateEmailLayout>
    <UpdateEmailSecurity {...props} />
  </UpdateEmailLayout>
);

export default UpdateEmailSecurityPage;
